export default __webpack_public_path__ + "static/media/img-0253-afghanistan-full-face.5ba97697.png";